<script>
export default {
    name: "Alert",
    props: {
        status: {
            type: String,
            default: 'default',
        },
        show: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            statusOption: {
                default: 'default',
                success: 'success',
                error: 'error',
            },
            display: this.show,
        }
    },
    watch: {
        show(newValue) {
            if ( newValue ) {
                this.display = newValue;
            }
        }
    }
}
</script>

<template>
    <div v-if="display" class="relative bg-green-200 border border-solid border-green p-5 flex justify-between gap-x-2.5" :class="statusOption[status]">
        <span class="text-2 !text-green"><slot/></span>
        <button @click="display = false" class="self-start pt-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14"><path fill="#418C6B" d="M13.707 1.707 12.293.293 7 5.586 1.707.293.293 1.707 5.586 7 .293 12.293l1.414 1.414L7 8.414l5.293 5.293 1.414-1.414L8.414 7l5.293-5.293Z"/></svg>
        </button> 
    </div>
</template>

<style scoped lang="scss">

</style>